import styles from './RTFBold.module.scss';

export default function RTFBold(text: React.ReactNode[]): React.ReactNode {
  return <span className={styles.bold}>{text}</span>;
}
